import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import DataTable from "../../admin/components/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { getBlogs } from "../../services/writerBlog";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from "@mui/material";

const BlogHome = () => {
  const [loaderOpen, setLoaderOpen] = React.useState(true);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [apiData, setApiData] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [showOptions, setShowOptions] = useState("Approve");
  const [selectedOptions, setSelectedOptions] = useState(new Map());
  const [showAlert, setShowAlert] = useState(false);
  const [showReasonPopup, setShowReasonPopup] = useState(false);
  const [reason, setReason] = useState("");
  const [currBlogId, setCurrBlogId] = React.useState("");
  const admin = useSelector((state) => state.admin);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { state } = useParams();
  const token = useSelector((state) => state.token);
  // Access the specific search key value
  let searchKeyValue = state;
  if (searchKeyValue == undefined) {
    searchKeyValue = "all";
  }

  const { id } = useParams();

  const tableColumns = [
    {
      field: "thumbnail",
      headerName: "IMAGE",
      width: 100,
      editable: false,
      renderCell: (params) => (
        <img
          src={params.row?.banner}
          alt="thumbnail"
          style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
        />
      ),
    },
    {
      field: "title",
      headerName: "TITLE",
      flex: 1,
      editable: false,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 230,
      editable: false,
      renderCell: (params) => (
        <div>
          <Tooltip title="Show Blog Details">
            <Button
              variant="outlined"
              onClick={() => handleBlogView(params)}
              className="circular-btn me-2"
              startIcon={<RemoveRedEyeRoundedIcon />}
            />
          </Tooltip>
          <Tooltip title="Edit Blog Details">
            <Button
              variant="outlined"
              onClick={() => editBlogView(params)}
              className="circular-btn me-2"
              startIcon={<EditIcon />}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoaderOpen(true);
      const response = await getBlogs(token);
      if (response.status !== 200) {
        showToastAlert(response?.data?.message, "error");
        return;
      }
      setApiData(response.data.blogs);
      setLoaderOpen(false);
    } catch (err) {
      throw new Error(err);
    }
  };
  const handleBlogView = (params) => {
    const slug = params.row.slug;
    window.open(`/blog/${slug}`)
  };

  const handleNewBlog = () => {
    navigate("/writer/blog/new");
  };

  const editBlogView = (params) => {
    const id = params.row._id;
    navigate(`/writer/blog/${id}`);
  };

  const closeBlogView = () => {
    setModalOpen(false);
  };

  const handleClose = () => {
    setShowAlert(false);
  };

  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px"
        }}
      >
        <Box mb={3}>
          <Button
            variant="outlined"
            component={Link}
            to="/writer"
            startIcon={<ArrowBackIcon />}
            sx={{ background: "yellow" }}
          >
            Home
          </Button>
        </Box>
        <h1 className="page-title-1 my-3">Blogs</h1>
        <button onClick={handleNewBlog} className="btn btn-primary">
          New Blog
        </button>
      </div>
      <DataTable data={apiData} columns={tableColumns} id="_id" />
      <CustomAlert />
    </div>
  );
};

export default BlogHome;
